var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_c('img',{attrs:{"src":require("../assets/img/common/empty.png"),"alt":""}}),_c('div',{staticClass:"text"},[_vm._v("404: 未找到该页面")])])
}]

export { render, staticRenderFns }